import { Injectable } from '@angular/core';
import { catchError, map, Observable } from 'rxjs';
import { DashboardApiService } from '../db-api.service';
import { SaveCustomFrameworkPayload } from '../../entities/custom-skills-framework.model';
import {
  RetiredSkillFrameworkVersion,
  RetirementPlan,
  SkillFramework,
  SkillFrameworkType,
} from '../../entities/skills-framework.model';

const FRAMEWORKS_URL = '/v1/corporation/skill_frameworks';

@Injectable({
  providedIn: 'root',
})
export class CorporationSkillFrameworksApiService extends DashboardApiService {
  getFramework(id: number, skillFrameworkVersionId?: number): Observable<SkillFramework> {
    const query = this._buildQueryString({ skill_framework_version_id: skillFrameworkVersionId });
    const base = `${FRAMEWORKS_URL}/${id}`;
    const endpoint = query ? `${base}?${query}` : base;

    return this._get(endpoint).pipe(
      map((res) => this._handleResponse(res, 'skill_framework')),
      catchError((res) => this._handleError(res)),
    );
  }

  deleteFramework(id: number): Observable<void> {
    return this._delete(`${FRAMEWORKS_URL}/${id}`).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }

  retireFramework(id: number): Observable<RetiredSkillFrameworkVersion> {
    return this._post(`${FRAMEWORKS_URL}/${id}/retire`, {}).pipe(
      map((res) => this._handleResponse(res, 'skill_framework_version')),
      catchError((res) => this._handleError(res)),
    );
  }

  getRetirementPlan(id: number): Observable<RetirementPlan> {
    return this._get(`${FRAMEWORKS_URL}/${id}/retirement_plan`).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }

  listFrameworks(type?: SkillFrameworkType): Observable<SkillFramework[]> {
    const query = this._buildQueryString({ type });
    const endpoint = query ? `${FRAMEWORKS_URL}?${query}` : FRAMEWORKS_URL;

    return this._get(endpoint).pipe(
      map((res) => this._handleResponse(res, 'skill_frameworks')),
      catchError((res) => this._handleError(res)),
    );
  }

  saveCustomFramework(id: number, payload: SaveCustomFrameworkPayload): Observable<SkillFramework> {
    return this._put(`${FRAMEWORKS_URL}/${id}`, payload).pipe(
      map((res) => this._handleResponse(res, 'skill_framework')),
      catchError((res) => this._handleError(res)),
    );
  }
}
